import revisionNumberList from "./stageName";

export default [...revisionNumberList];
